<template>
  <div class="row receiver-sector__address-info g-2" v-if="hasCvs711Shop">
    <el-divider />

    <AccountAddressModel 
      v-if="showUads" 
      ref="addressRef"
      v-model="uadsState" 
      type="cvs_pcsc" 
      @ok="chooseAddress" 
    />
    
    <el-form-item v-if="(uadsState.uads_id === -1)" :label="showUads ? '' : t('orders.shop711')" required>
      <el-row :gutter="10" style="width: 100%;">
        <el-col :xs="24" :sm="8" class="mb-3">
          <el-form-item :prop="['cvs_711_shop_form', 'province']">
            <el-select
              v-model="form.cvs_711_shop_form.province"
              :disabled="state.cvs_711_provinces.length <= 0"
              :placeholder="`---${t('users.province')}---`" 
              size="large"
              style="width: 100%;"
              @change="get711Shops('distinct')"
            >
              <el-option
                v-for="obj in state.cvs_711_provinces"
                :key="obj.name"
                :label="obj.name"
                :value="obj.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="8" class="mb-3">
          <el-form-item :prop="['cvs_711_shop_form', 'distinct']">
            <el-select
              v-model="form.cvs_711_shop_form.distinct"
              :disabled="state.cvs_711_distincts.length <= 0"
              :placeholder="`---${t('users.city')}---`" 
              size="large"
              style="width: 100%;"
              @change="get711Shops('road')"
            >
              <el-option
                v-for="obj in state.cvs_711_distincts"
                :key="obj.name"
                :label="obj.name"
                :value="obj.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="8" class="mb-3">
          <el-form-item :prop="['cvs_711_shop_form', 'road']">
            <el-select
              v-model="form.cvs_711_shop_form.road"
              :disabled="state.cvs_711_roads.length <= 0"
              :placeholder="`---${t('users.road')}---`" 
              size="large"
              style="width: 100%;"
              @change="get711Shops('shop')"
            >
              <el-option
                v-for="obj in state.cvs_711_roads"
                :key="obj.name"
                :label="obj.name"
                :value="obj.name"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24" class="mb-3">
          <el-form-item prop="cvs_711_shop_id">
            <el-select
              v-model="form.cvs_711_shop_id"
              :disabled="state.cvs_711_shops.length <= 0"
              :placeholder="`---${t('orders.mart')}---`" 
              size="large" style="width: 100%;"
            >
              <el-option
                v-for="obj in state.cvs_711_shops"
                :key="obj.shop_id"
                :label="obj.shop_name + ' - ' + obj.shop_address_full"
                :value="obj.shop_id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script setup>
import { computed, ref, reactive } from 'vue'
import { useI18n } from "vue-i18n"
import { useVModels } from '@vueuse/core'
import { _api_get711Shops, } from "../../api/index.js";
import AccountAddressModel from './AccountAddressModel.vue'

const props = defineProps({
  form: Object,
  state: Object,
  usedLogisticTypes: Array,
  isEdit: Boolean,
  showUads: Boolean,
})
const emit = defineEmits(['update:state', 'update:form'])

const { t, locale } = useI18n()
const { state, form } = useVModels(props, emit)

const logistic_types = ['C2CUNIMART', 'C2CUNIMART.COD'];
const twOuterIslands = ["連江縣", "金門縣", "澎湖縣", "綠島鄉", "蘭嶼鄉", "琉球鄉"]; 

// const isCreate = computed(() => form.value.uads_cvs_pcsc)
const isCreate = computed(() => uadsState.uads_id === -1)

const get711Shops = (field) => {
  const data = {
    'field': field,
    'province': form.value.cvs_711_shop_form.province,
    'distinct': form.value.cvs_711_shop_form.distinct,
    'road': form.value.cvs_711_shop_form.road,
  };
  // 檢查外島配送
  if (field == "distinct" || field == "road") {
    if (alertOuterIsland(data)) {
      console.log("get711Shops: ", data)
      return;
    }
  }
  uadsState.isOuterIsland = isOuterIsland.value
  // console.log("get711Shops: ", res); return;
  window.fullPageLoading("show");
  _api_get711Shops(data)
    .then((res) => {
      // console.log("711 shop -> field:", field, ", reps:", res)
      // console.log("isOuterIsland: ", isOuterIsland.value);
      if (field == "province") {
        if (isOuterIsland.value) {
          state.value.cvs_711_provinces = res.data
        } else {
          state.value.cvs_711_provinces = res.data.filter((el) => !twOuterIslands.includes(el.name))
          // console.log("cvs_711_provinces", state.value.cvs_711_provinces)
        }

        if (isEdit.value) {
          get711Shops('distinct')
        } else {
          form.value.cvs_711_shop_form.province = null
          form.value.cvs_711_shop_form.distinct = null
          form.value.cvs_711_shop_form.road = null
          form.value.cvs_711_shop_id = null
          state.value.cvs_711_distincts = []
          state.value.cvs_711_roads = []
          state.value.cvs_711_shops = []
        }
      } else if (field == "distinct") {
        if (isOuterIsland.value) {
          state.value.cvs_711_distincts = res.data
        } else {
          state.value.cvs_711_distincts = res.data.filter((el) => !twOuterIslands.includes(el.name))
          // console.log("cvs_711_distincts", state.value.cvs_711_distincts)
        }
        if (isEdit.value) {
          get711Shops('road')
        } else {
          form.value.cvs_711_shop_form.distinct = null
          form.value.cvs_711_shop_form.road = null
          form.value.cvs_711_shop_id = null
          state.value.cvs_711_roads = []
          state.value.cvs_711_shops = []
        }
      } else if (field == "road") {
        state.value.cvs_711_roads = res.data
        if (isEdit.value) {
          get711Shops('shop')
        } else {
          form.value.cvs_711_shop_form.road = null
          form.value.cvs_711_shop_id = null
          state.value.cvs_711_shops = []
        }
      } else if (field == "shop") {
        state.value.cvs_711_shops = res.data
        if (isEdit.value) {
          isEdit.value = false
        } else {
          form.value.cvs_711_shop_id = null
        }
      }
    })
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      window.fullPageLoading("hide");
    })
}
const isEdit = ref(props.isEdit)
const addressRef = ref()
const uadsState = reactive({
  uads_id: -1,
  isOuterIsland: false,
})

const chooseAddress = async (choose = null) => {
  console.log("chooseAddress: ", choose)
  form.value.cvs_711_shop_form.province = null
  form.value.cvs_711_shop_form.distinct = null
  form.value.cvs_711_shop_form.road = null
  form.value.cvs_711_shop_id = null
  form.value.to_name = form.value.buyer_name
  form.value.to_mobile = form.value.buyer_mobile
  form.value.uads_cvs_pcsc = true
  isEdit.value = false
  state.value.showToInfo = false
  if (choose) {
    form.value.cvs_711_shop_form.province = choose.shop.shop_province
    form.value.cvs_711_shop_form.distinct = choose.shop.shop_distinct
    form.value.cvs_711_shop_form.road = choose.shop.shop_road
    form.value.cvs_711_shop_id = choose.shop.shop_id

    form.value.to_name = choose.to_name
    form.value.to_mobile = choose.to_mobile
    state.value.showToInfo = true
    
    form.value.uads_cvs_pcsc = false
    // isEdit.value = true
    // await get711Shops('distinct');
    const data = {
      'field': 'distinct',
      'province': choose.shop.shop_province,
      'distinct': choose.shop.shop_distinct,
      'road': choose.shop.shop_road,
    };
    const distinctRes = await alertOuterIsland(data)
    if (!distinctRes) {
      alertOuterIsland({...data, field: "road"})
    }
  }
}

const logistic = ref(null)
const chkLocation = (logistic_type) => {
  const target = logistic_types.includes(logistic_type)
  if (target) { 
    logistic.value = logistic_type
    if (state.value?.isOuterIsland && !(logistic.value in state.value.isOuterIsland)) {
      state.value.isOuterIsland[logistic.value] = false
    }
  }
  return target
}
const handleUnchecked = () => {
  const carts = form.value.carts.filter((el) => !el.checked && el.is_excluded_outer_island)
  carts.forEach((cart) => {
    if (chkLocation(cart.logistic_type)) {
      cart.checked = false
      cart.is_valid = false
    }
  })
}
const alertOuterIsland = (data) => {
  let val = null
  if (data.field == "distinct") {
    val = data.province
  }
  else if (data.field == "road") {
    val = data.distinct
  }
  
  // console.debug("val: ", val)
  if (form.value.country != 'TW' || !form.value?.carts) {
    return false
  }
  const key = val
  // console.debug("alertOuterIsland:", key, data)
  // console.debug("twOuterIslands:", twOuterIslands)
  if (!twOuterIslands.includes(key)) {
    if (data.field == "road" && twOuterIslands.includes(data.province)) {
      return false
    }
    const carts = form.value.carts.filter((el) => !el.is_valid && el.is_excluded_outer_island)
    carts.forEach((cart) => {
      if (chkLocation(cart.logistic_type)) {
        cart.checked = true
        cart.is_valid = true
      }
      state.value.isOuterIsland[logistic.value] = false
    })
    return false
  }
  // console.debug("alertOuterIsland: ", key)
  state.value.isOuterIsland[logistic.value] = true
  const cart_ids = []
  const items = []
  // 檢查購物車 is_excluded_outer_island
  const carts = form.value.carts.filter((el) => el.checked && el.is_excluded_outer_island)
  
  carts.forEach((cart) => {
    if (chkLocation(cart.logistic_type)) {
      // console.debug("cart: ", cart)
      items.push(cart.product_name)
      cart_ids.push(cart.cart_id)
    }
  })
  if (items.length) {
    swal.fire({
      title: '部分商品不支援離島寄送',
      html: items.join("<br />"),
      allowOutsideClick: false,
      showCancelButton: true,
      confirmButtonColor: 'var(--secondary_color)',
      confirmButtonText: '取消勾選外島商品',
      cancelButtonColor: 'var(--primary_color)',
      cancelButtonText: '重選地址',
    }).then((result) => {
      // console.debug("result: ", result)
      if (result.value) {
        console.debug("取消勾選外島商品")
        // console.debug("cart_ids: ", cart_ids)
        carts.forEach((cart) => {
          if (cart_ids.includes(cart.cart_id)) {
            cart.checked = false
            cart.is_valid = false
          }
        })
        get711Shops(data.field)
        
      } else if (result.dismiss == "cancel") {
        console.debug("重選地址", uadsState.uads_id)
        if (uadsState.uads_id === -1) {
          form.value.cvs_711_shop_form.distinct = null
          form.value.cvs_711_shop_form.road = null
          form.value.cvs_711_shop_id = null
          state.value.cvs_711_roads = []
          state.value.cvs_711_shops = []
          if (data.field == "distinct") {
            form.value.cvs_711_shop_form.province = null
            state.value.cvs_711_distincts = []
          }
        } else {
          uadsState.uads_id = -1
          chooseAddress()
        }
        
        state.value.isOuterIsland[logistic.value] = false
      }
    })
    return true
  } else {
    handleUnchecked()
  }
}

const hasCvs711Shop = computed(() => {
  const target = props.usedLogisticTypes.find(val => chkLocation(val));
  // console.log("hasSelectedDistinct: ", hasSelectedDistinct.value)
  const has_711 = !!target;
  
  // console.log("cvs_711_distincts: ", state.value.cvs_711_distincts)
  if (has_711 && !state.value.cvs_711_provinces.length) {
    get711Shops('province');
  }

  return has_711;
});

const isOuterIsland = computed(() => {
  const target = props.usedLogisticTypes.find(val => chkLocation(val));
  if (!state.value?.logistics) {
    // 會員常用地址
    return true
  }
  const item = state.value?.logistics.find((el) => el.type === target)
  if (!item) return false
  const rate = item.rates.find((rate) => rate.countries.includes(form.value.country))
  if (rate?.fees.length) {
    return rate?.fees[0]?.is_open_outer_island
  }
  return false
})

defineExpose({ addressRef, isEdit, isCreate, uadsState })

</script>
